import CloseIcon from "@mui/icons-material/Close";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Grid,
  IconButton,
  Modal,
  TextField,
  Typography
} from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import Loader from "../../common/Loader";
import {
  FETCH_CLIENT_EMPLOYEE_V2,
  FETCH_CLIENTS_EMPLOYEES_V2,
  SAVE_CLIENT_COACHING
} from "../../constant/Apipath";
import { BIBlue, BILightGrey } from "../../assets/helpers";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";

function AddCoaching({ open, handleClose }) {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const LANGUAGE = ClientEnglishFallback.ClientCoachingAddModal(
    multiLanguageData?.ClientCoachingAddModal || {}
  );
  const {
    TEXT_EMPLOYEE,
    TEXT_COACHINGFORM_PLACEHOLDER_FIRST,
    TEXT_DESCRIPTION,
    TEXT_COACHINGFORM_PLACEHOLDER_SECOND,
    TEXT_SUBMIT_ANONYMOUSLY,
    TEXT_SUBMIT
  } = LANGUAGE;

  const [clientEmployeData, setClientEmployeData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTermFlag, setSearchTermFlag] = useState(false);
  const [ClientCoaching, setClientCoaching] = useState({
    employee: {
      id: 0,
      label: ""
    },
    searchTerm: "",
    description: "",
    checked: false
  });
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);
  const [timeoutId, setTimeoutId] = useState(null);

  useEffect(() => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    const newTimeoutId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    setTimeoutId(newTimeoutId);

    return () => {
      clearTimeout(newTimeoutId);
    };
  }, [searchTerm]);

  useEffect(() => {
    if (debouncedSearchTerm !== undefined) {
      getInitialData();
    }
  }, [debouncedSearchTerm]);

  const getInitialData = async () => {
    await getClientEmployeeData();
    setIsLoading(false);
  };

  const getClientEmployeeData = async () => {
    try {
      let obj = {
        PageNr: 1,
        NrOfRecPerPage: 20,
        FullSearch: searchTermFlag ? "" : searchTerm,
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            ClientId: selectedClientData?.ClientId
          }
        ]
      };

      const clientEmployeeResponse = await Postrequestcall(
        // FETCH_CLIENT_EMPLOYEE_V2,
        FETCH_CLIENTS_EMPLOYEES_V2,
        obj,
        loginData?.accessToken
      );
      if (clientEmployeeResponse.status === 200) {
        const datas = clientEmployeeResponse?.data?.data;
        const updatedData = datas
          ?.map((data) => {
            if (data?.userId !== loginData?.userInformation?.UserId) {
              return {
                id: data.id,
                label: `${data.firstName} ${data.lastName}`
              };
            }
            return null;
          })
          .filter((item) => item !== null);
        setClientEmployeData(updatedData);
      }
    } catch (error) {
      console.log("getClientEmployeeData-> Error Getting Client Employee Data: ", error);
    }
  };

  const handleInputChange = (value, field) => {
    setClientCoaching((prevState) => ({
      ...prevState,
      [field]: value
    }));
  };

  const shouldDisable = () => {
    return ClientCoaching.employee.id !== 0 && ClientCoaching.description !== "";
  };

  const saveClientCoaching = async () => {
    try {
      setIsLoading(true);
      const obj = {
        ReturnRecordId: true,
        ReturnRecordError: true,
        UserId: loginData?.userInformation?.UserId,
        SaveList: [
          {
            Id: 0,
            ClientEmployeeId: ClientCoaching.employee.id,
            Description: ClientCoaching.description.trim(),
            SubmitAnonymously: ClientCoaching.checked ? 1 : 0,
            ModifiedBy: loginData?.userInformation?.UserId
          }
        ]
      };
      const isRecordSaved = await Postrequestcall(
        SAVE_CLIENT_COACHING,
        obj,
        loginData?.accessToken
      );
      if (isRecordSaved.status === 201) {
        setIsLoading(false);
        handleClose(true);
      }
      setIsLoading(false);
    } catch (error) {
      console.log("saveClientCoaching-> Error When Saving Client Coaching: ", error);
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-add-client-support"
        aria-describedby="modal-add-client">
        <>
          {isLoading ? (
            <Loader fullScreen />
          ) : (
            <Box className="client-modal-responsive">
              <div
                style={{
                  justifyContent: "flex-end"
                }}
                className="action-button-container">
                <IconButton
                  onClick={handleClose}
                  sx={{
                    display: "flex",
                    justifySelf: "flex-end",
                    color:
                      selectedClientData?.AccentColor !== undefined &&
                        selectedClientData?.AccentColor
                        ? selectedClientData?.AccentColor
                        : BILightGrey
                  }}>
                  <CloseIcon />
                </IconButton>
              </div>
              <Grid container spacing={1}>
                <Grid size={12}>
                  <Typography variant="body1">{TEXT_EMPLOYEE}</Typography>
                  <Autocomplete
                    inputValue={searchTermFlag ? ClientCoaching?.employee?.label : searchTerm}
                    value={ClientCoaching.employee.id ? ClientCoaching.employee : null}
                    onInputChange={(event, value) => {
                      if (event && event.target && typeof event.target.value === "string") {
                        let inputValue = event.target.value;
                        inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
                        setSearchTerm(inputValue);
                        setSearchTermFlag(false);
                      } else {
                        setSearchTermFlag(true);
                        setSearchTerm("");
                      }
                    }}
                    size="small"
                    id="Roles"
                    options={clientEmployeData}
                    onChange={(e, selectedEmployee) => {
                      if (selectedEmployee) {
                        handleInputChange(selectedEmployee, "employee");
                      } else {
                        handleInputChange({ id: 0, label: "" }, "employee");
                      }
                    }}
                    style={{ backgroundColor: "#e4e4e4", borderRadius: "10px" }}
                    sx={{ "& fieldset": { border: "none" } }}
                    getOptionLabel={(option) => `${option?.label}`}
                    renderInput={(params) => {
                      return (
                        <TextField
                          {...params}
                          variant="outlined"
                          placeholder={TEXT_COACHINGFORM_PLACEHOLDER_FIRST}
                        />
                      );
                    }}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                  />
                </Grid>
                <Grid size={12}>
                  <Typography variant="body1">{TEXT_DESCRIPTION}</Typography>
                  <TextField
                    size="small"
                    variant="outlined"
                    required
                    fullWidth
                    onChange={(e) => {
                      let inputValue = e.target.value;
                      inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
                      handleInputChange(inputValue, "description");
                    }}
                    value={ClientCoaching.description}
                    minRows={4}
                    slotProps={{
                      input: {
                        rows: 4,
                        multiline: true,
                        inputComponent: "textarea"
                      }
                    }}
                    placeholder={TEXT_COACHINGFORM_PLACEHOLDER_SECOND}
                    className="add-support"
                    sx={{
                      "& fieldset": { border: "none" }
                    }}
                  />
                </Grid>
                <Grid
                  size={12}
                  sx={{ display: "flex", alignItems: "center" }}
                  onClick={() => handleInputChange(!ClientCoaching.checked, "checked")}>
                  <Checkbox
                    checked={ClientCoaching.checked}
                    sx={{
                      "&.Mui-checked": {
                        color: selectedClientData?.AccentColor // Sets the checked state color
                      }
                    }}
                  />{" "}
                  {TEXT_SUBMIT_ANONYMOUSLY}
                </Grid>
                <Grid size={12} sx={{ overflowX: "auto", display: "flex" }}>
                  <Button
                    disabled={!shouldDisable() || isLoading}
                    variant="contained"
                    sx={{
                      backgroundColor: selectedClientData?.AccentColor,
                      borderRadius: "10px",
                      textTransform: "none",
                      color: "white"
                    }}
                    fullWidth
                    onClick={saveClientCoaching}>
                    {TEXT_SUBMIT}
                  </Button>
                </Grid>
              </Grid>
            </Box>
          )}
        </>
      </Modal>
    </div>
  );
}

export default AddCoaching;
